import React,{Fragment, useEffect}           from 'react'
import { Button, FormGroup, Spinner }        from 'reactstrap';

const ButtonComponent=({routeBack,onSaveClick, onNihilClick, loading})=>{

    let status = false

    if(loading != undefined) {
        status = loading
    }

    return(
        <FormGroup>
            <div className='d-flex justify-content-between'>
                <div>
                    {/* <Button onClick={onNihilClick} color="success" type="submit" className="">Input Nihil</Button> */}
                </div>

                <div className="text-right">
                    <Button onClick={routeBack} outline color="primary">Batal</Button>&nbsp;
                    <Button onClick={onSaveClick} color="primary" type="submit" disabled={status}>
                        {
                            status == false ? "Simpan" : <Spinner size="sm" />
                        }
                        
                    </Button>
                </div>
            </div>
        </FormGroup>
    )
}

export default ButtonComponent;